import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';

/**
 * Check if the value is null undefined ''
 *
 * @param value
 */
var checkNotEmpty = function checkNotEmpty(value) {
  return value === '' || value === undefined || value === null;
};
/**
 * @param value: number
 * @param comparator: number
 * @param value
 * @param comparator
 */

var greaterThan = function greaterThan(value, comparator) {
  return value > comparator;
};
/**
 * Check if a valid date with format MM/DD/YYYY
 *
 * @param {*} value: string
 * @param value
 */

var validDate = function validDate(value) {
  var dateValidationRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
  if (!dateValidationRegex.test(value)) return false;

  var _value$split$map = value.split('/').map(function (n) {
    return Number(n);
  }),
      _value$split$map2 = _slicedToArray(_value$split$map, 3),
      m = _value$split$map2[0],
      d = _value$split$map2[1],
      y = _value$split$map2[2];

  return m === Number(new Date(y, m - 1, d).getMonth()) + 1 && d === Number(new Date(y, m - 1, d).getDate());
};
var equal = function equal(a, b) {
  return a === b;
};
var notEqual = function notEqual(a, b) {
  return !equal(a, b);
};
var isNull = function isNull(a) {
  return checkNotEmpty(a);
};
var isNotNull = function isNotNull(a) {
  return !isNull(a);
};
var isIn = function isIn(a, b) {
  return b.indexOf(a) > -1;
};
var isNotIn = function isNotIn(a, b) {
  return !isIn(a, b);
};
var greaterThanOrEquals = function greaterThanOrEquals(value, comparator) {
  return value >= comparator;
};
var lessThanOrEquals = function lessThanOrEquals(value, comparator) {
  return value <= comparator;
};
var startsWith = function startsWith(value, comparator) {
  return String(value).startsWith(comparator);
};
var contains = function contains(value, comparator) {
  return String(value).includes(comparator);
};

export { checkNotEmpty, contains, equal, greaterThan, greaterThanOrEquals, isIn, isNotIn, isNotNull, isNull, lessThanOrEquals, notEqual, startsWith, validDate };
//# sourceMappingURL=operators.js.map
